import { Image, ImageProps, Skeleton } from '@chakra-ui/react';
import { Message } from '@outdoorly/chat-sdk';
import React, { useCallback, useEffect, useState } from 'react';

type Props = {
  width?: undefined | number;
  height?: undefined | number;
  imageProps: ImageProps;
  src: string;
};

export const SkeletonImage: React.FC<Props> = ({ width, height, imageProps = {}, src }) => {
  const [loaded, setHasLoaded] = useState(false);

  const { role, onClick, ...skeletonProps } = imageProps;
  return (
    <>
      {src && (
        <Image
          width={width}
          height={height}
          src={src}
          onLoad={() => setHasLoaded(true)}
          hidden={!loaded}
          role={role}
          onClick={onClick}
          {...imageProps}
        />
      )}
      <Skeleton {...skeletonProps} hidden={loaded} />
    </>
  );
};

export const SkeletonChatImage: React.FC<{
  media: NonNullable<Message['attachedMedia']>[number];
  scrollToBottomIfClose: () => void;
}> = (props) => {
  const { media, scrollToBottomIfClose } = props;
  const [src, setSrc] = useState<string | null>('');
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const getMediaUrl = async (media: NonNullable<Message['attachedMedia']>[number]) => {
      const result = await media.getContentTemporaryUrl();
      setSrc(result);
    };
    getMediaUrl(media);
  }, []);
  const onLoad = useCallback(() => {
    setLoaded(true);
    scrollToBottomIfClose();
  }, []);
  const onClick = useCallback(() => {
    src && window.open(src, '_blank');
  }, [src]);

  return (
    <>
      {src && (
        <Image
          src={src}
          hidden={!loaded}
          onLoad={onLoad}
          borderRadius="8px"
          cursor="zoom-in"
          onClick={onClick}
        />
      )}
      <Skeleton w="80px" h="80px" hidden={Boolean(src && loaded)} />
    </>
  );
};
